import clientSdk from '../../../services/client-sdk';
import sdk from '../../../services/reg-code-sdk';

/*******************************************************************************
 * Initial state
 */
const initialState = {
  codes: [],
  codesLoading: false,
  codesLoadingError: null,
  clients: {},
  clientLoading: false,
  clientLoadingError: null
};

/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'codes/setState';

/*******************************************************************************
 * Reducer
 */
export default function codesReducer( state = initialState, action ) {
  switch ( action.type ) {
    case SET_STATE: {
      return {
        ...state,
        ...action.state
      };
    }
    default:
      return state;
  }
}

/*******************************************************************************
 * Action creators
 */
function setState( state ) {
  return {
    type: SET_STATE,
    state
  };
}

function getCodes( regId ) {
  return dispatch => {
    if ( regId ) {
      dispatch(
        setState( {
          programLoading: true,
          programLoadingError: null
        } )
      );

      sdk
        .getCode( regId )
        .then( codes => {
          dispatch(
            setState( {
              codes,
              codesLoading: false
            } )
          );
        } )
        .catch( err => {
          dispatch(
            setState( {
              codesLoading: false,
              codesLoadingError: err
            } )
          );
        } );
    }
  };
}

function getRegId() {
  return dispatch => {
    dispatch(
      setState( {
        clientLoading: true,
        clientLoadingError: null
      } )
    );

    clientSdk
      .getClients()
      .then( clients => {
        dispatch(
          setState( {
            clients,
            clientLoading: false
          } )
        );
      } )
      .catch( err => {
        dispatch(
          setState( {
            clientLoading: false,
            clientLoadingError: err
          } )
        );
      } );
  };
}

function clearCodes() {
  return dispatch => {
    initialState.codes = [];

    dispatch(
      setState( {
        ...initialState
      } )
    );
  };
}

export const actions = {
  getCodes,
  getRegId,
  clearCodes
};
